import api from './api.png';
import email from './email.png';
import facebook from './facebook.png';
import google from './google.png';
import line from './line.png';
import microsoft from './microsoft.png';
import phone from './phone.png';
import rcs from './rcs.png';
import sms from './sms.png';
import telegram from './telegram.png';
import twilio from './twilio.png';
import twitter from './twitter.png';
import website from './website.png';
import whatsapp from './whatsapp.png';

export default {
  api,
  email,
  facebook,
  google,
  line,
  microsoft,
  phone,
  rcs,
  sip: phone,
  sms,
  telegram,
  twilio,
  twitter,
  website,
  whatsapp,
};
